import React from "react";
import "../CSS/ServicesPage.css";
import { Link } from "react-router-dom";

const ServicesPage = () => {
  return (
    <section className="svc-page">

      <div className="svc-banner">
        <h1>Apostille & Document Attestation Services in Mumbai</h1>
        <p>
          <Link to="/">Home</Link> &gt; <span>Services</span>
        </p>
      </div>

      <div className="svc-wrapper">

        <aside className="svc-sidebar">

          <div className="svc-box">
            <h3>APOSTILLE SERVICES</h3>
            <ul>
              <li>Educational Document Apostille</li>
              <li>Personal Document Apostille</li>
              <li>Commercial Document Apostille</li>
            </ul>
          </div>

          <div className="svc-box">
            <h3>QUICK LINKS</h3>
            <ul>
              <li>Apostille Services in Mumbai</li>
              <li>Document Apostille Process</li>
              <li>MEA Approved Universities</li>
              <li>Apostille Country List</li>
              <li>Non Apostille Country List</li>
              <li>Apostille Accepted Embassy List</li>
              <li>Apostille Member Countries</li>
              <li>Apostille Centers – Mumbai</li>
            </ul>
          </div>

        </aside>

        <main className="svc-content">

          <h2>Professional Apostille & Document Attestation Services in Mumbai</h2>

          <p>
            Apostille.net.in provides reliable <strong>MEA apostille and
            document attestation services in Mumbai</strong> for individuals,
            students, and businesses. Our services help ensure that your
            documents are legally recognized in foreign countries for
            employment, higher education, immigration, or international
            business purposes.
          </p>

          <p>
            Our Mumbai apostille experts manage the complete document
            authentication process including verification, attestation,
            and apostille from the <strong>Ministry of External Affairs
            (MEA), Government of India</strong>. We ensure fast processing,
            transparency, and secure handling of all documents.
          </p>

          <p>
            Whether you are applying for a job abroad, planning to study
            overseas, or expanding your business internationally, our
            apostille services in Mumbai make the documentation process
            smooth and hassle-free.
          </p>

          <h3>Documents We Apostille in Mumbai</h3>

          <p>
            Our Mumbai apostille services cover a wide range of document
            categories required for international use.
          </p>

          <ul className="svc-list">
            <li>Educational Documents Apostille</li>
            <li>Personal / Private Documents Apostille</li>
            <li>Commercial / Business Documents Apostille</li>
          </ul>

          <h3>Educational Document Apostille in Mumbai</h3>

          <p>
            We provide apostille services for educational documents issued
            by schools, colleges, and universities in Mumbai and across
            Maharashtra.
          </p>

          <h3>Personal Document Apostille in Mumbai</h3>

          <p>
            Personal or non-educational documents often require apostille
            for immigration, family visa, residency permits.
          </p>

          <h3>Commercial Document Apostille in Mumbai</h3>

          <p>
            Businesses in Mumbai involved in international trade require
            authentication of commercial documents.
          </p>

        </main>

      </div>

    </section>
  );
};

export default ServicesPage;